import Component from '../abstracts/Component';

export default class HeroCROComponent extends Component {

  get SELECTORS() {
    return {
      heroComponents: '[data-js-component=HeroCROComponent]',
      header: '.main-header',
      benefitbar: '.benefit-bar',
      heroContainer: '.c-hero-cro',
      videoContainer: '.c-hero-cro .brightcove-wrapper',
      wrapper: '#wrapper'
    };
  }

  get CLASSES() {
    return {
      irresponsive: 'not-responsive',
      responsive: 'responsive',
      fullHeight: 'height-full',
      headerTransparent: 'header-transparent',
      headerTransparentReverse: 'header-transparent-reverse',
      heroContainer: 'c-hero-cro',
    };
  }

  constructor() {
    super();
    // get html
    this.$myComponent = (this.$component !== null && typeof this.$component !== 'undefined') ? this.$component[0] : document.querySelector('[data-js-component=HeroCROComponent]');
    // dom elems
    this.mainWrapper = document.querySelector(this.SELECTORS.wrapper);
    this.heroComponents = document.querySelectorAll(this.SELECTORS.heroComponents);
  }

  // general
  setHeaderCss() {
    // root element
    let r = document.querySelector(':root');
    // for header transparent
    let header = document.querySelector(this.SELECTORS.header);
    // set value of variable for header transparent
    r.style.setProperty('--header-offset-desktop', '-' + parseInt(header.offsetHeight,10) + 'px');
    // for standard header
    let benefitbar = document.querySelector(this.SELECTORS.benefitbar);
    let offset = parseInt(header.offsetHeight,10) + parseInt(benefitbar.offsetHeight,10);
    let searchbar = document.querySelector('.search-header.is-visible');
    // if search bar is visible -> on landing on page
    if (searchbar !== null) {
      offset =  parseInt(offset + searchbar.offsetHeight,10);
      if (this.$matchMedia(null, 'lg')) {
        // if is destkop large i have the translateY to compensate
        offset =  parseInt(offset - 73);
      }
    }
    let hero_height = parseInt(window.innerHeight,10) - offset ;
    // set value of variable for standard header
    r.style.setProperty('--hero-cro-height', hero_height + 'px');
  }

  headerScrollControl(setclass,eventPayload) {
    let header = document.querySelector(this.SELECTORS.header);
    // check
    if (header === null || !header.classList.contains(this.CLASSES.headerTransparent)) return false;
    //
    if (setclass) {
      header.classList.add(this.CLASSES.headerTransparentReverse);
    } else {
      header.classList.remove(this.CLASSES.headerTransparentReverse);
    }
    // if is back on top
    if (eventPayload.scroll === 0) {
      header.classList.remove(this.CLASSES.headerTransparentReverse);
    }
  }

  // scroll all wrapper elements
  positionChecker() {
    // context
    let ctx = this;
    // let's loop the children
    this.mainWrapper.childNodes.forEach( (child,index) => {
      // no action for component not hero
      if (!child.classList.contains(ctx.CLASSES.heroContainer)) return;
      // if there is a hero in the first position
      if (index !== 1) {
        // enter here only if not in first position
        child.classList.add(this.CLASSES.irresponsive);
        child.classList.remove(this.CLASSES.headerTransparent);
        child.classList.remove(this.CLASSES.responsive);
        child.classList.remove(this.CLASSES.fullHeight);
      } else {
        // if is first I need to put a class
        child.classList.remove(this.CLASSES.irresponsive);
        child.classList.add(this.CLASSES.responsive);
      }
    });
  }

  // for each component
  renderSingleComponent(heroComponent) {
    // vars
    let ctx = this;
    // dom ready
    // hero CRO video
    this.adjustVideoPosition(heroComponent);
    // events
    // event on resize
    window.addEventListener('resize', () => {
      // hero CRO video
      ctx.adjustVideoPosition(heroComponent);
    });
    // event on scroll
    window.addEventListener('scroll', () => {
      // hero CRO video
      ctx.adjustVideoPosition(heroComponent);
    });
    // hero CRO video
    document.addEventListener('video:loadedData', function (event) {
      ctx.adjustVideoPosition(heroComponent);
    });
  }

  adjustVideoPosition(heroContainer) {
    let  videoContainer = heroContainer.querySelector(this.SELECTORS.videoContainer);
    // check
    if (videoContainer === null) return false;
    // get video divs
    let videoJS = videoContainer.querySelector('video-js');
    let video = videoContainer.querySelector('video-js video');
    // re-check
    if (videoJS === null || video === null ) return false;
    // reset always
    video.style.transform = 'translateY(0)';
    videoJS.style.transform = 'translateX(0)';
    videoJS.style.width = '100%';
    // check is mobile
    if (!this.$matchMedia(null, 'md')) return false;
    // check if is first component or not
    if (heroContainer.classList.contains(this.CLASSES.irresponsive)) return false;
    // video AR configuration
    let videoARconf = videoContainer.dataset.aspectratio;
    let videoARconfArray = videoARconf.split(':');
    let videoARconfCalculated = parseInt(videoARconfArray[0],10) / parseInt(videoARconfArray[1],10);
    // get video viewport aspect radio
    let videoARreal = videoContainer.offsetWidth / videoContainer.offsetHeight ;
    // check AR
    if (videoARconfCalculated > videoARreal) {
      // if setting is higher than viewport -> video height is less than viewport
      // calc new width with AR from conf, put into the video
      let newWidth = videoContainer.offsetHeight * videoARconfCalculated;
      videoJS.style.width = newWidth + 'px';
      // calc the translation X with difference from width
      let translationX = (newWidth - videoContainer.offsetWidth ) / 2;
      videoJS.style.transform = 'translateX(-' + translationX + 'px)';
    } else {
      // if setting is lower than viewport -> video height is more than viewport
      let translationY = (video.offsetHeight - videoJS.offsetHeight) / 2;
      // put 100 width ( already with css )
      videoJS.style.width = '100%';
      // calc the translation Y with difference from width, but apply to video ( not video-js )
      video.style.transform = 'translateY(-'+translationY+'px)';
    }
  }

  // general events
  bindEvents() {
    //
    let ctx = this;
    // event on resize
    window.addEventListener('resize', () => {
      // hero CRO helper
      this.setHeaderCss();
    });
    // event on scroll
    window.addEventListener('scroll', () => {
      // hero CRO helper
      this.setHeaderCss();
    });

    // header transparent check
    this.$on(this.$customEvents.HEADER_EVENTS.expanded, (e) => {
      //
      this.headerScrollControl(true,e.payload);
    });
    this.$on(this.$customEvents.HEADER_EVENTS.collapsed, (e,p) => {
      //
      this.headerScrollControl(false,e.payload);
    });
  }

  render() {
    this.log('rendering...');
    // check
    if (this.heroComponents === null) return false;
    // cycle the components
    this.heroComponents.forEach(heroComponent => {
      this.renderSingleComponent(heroComponent);
    });
    // events
    this.bindEvents();
    // hero CRO helper
    this.setHeaderCss();
    // heros CRO position checker
    this.positionChecker();
  }
}
